import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'settings',
  templateUrl: './settings.component.html',
})
export class SettingsComponent {
  constructor(private router: Router) {}

  goToSettings(): void {
    this.router.navigate(['/apps/settings']);
  }
}
